var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefferralsProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16.375px",
    height: "16.25px",
    viewBox: "0 0 16.375 16.25",
    enableBackground: "new 0 0 16.375 16.25",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E9",
    d: "M8.218,0.208c-2.031,0.02-3.167,1.527-3.167,3.167c0,1.491,1.018,2.707,2.375,3.068V4.167 c0.001-0.438,0.354-0.793,0.792-0.792C8.655,3.376,9.011,3.729,9.01,4.167v1.36c0.465-0.848,1.64-1.803,3.166-2.078 C11.764,1.483,10.064,0.19,8.218,0.208z M3.542,4.167C1.576,4.58,0.284,6.279,0.301,8.125c0.02,2.031,1.527,3.167,3.167,3.167 c1.491,0,2.706-1.018,3.067-2.375H4.26C3.823,8.916,3.467,8.563,3.468,8.125C3.469,7.688,3.823,7.333,4.26,7.333h1.361 C4.772,6.869,3.817,5.694,3.542,4.167z M12.969,4.958c-1.491,0-2.707,1.018-3.068,2.375h2.275c0.438,0.001,0.793,0.355,0.793,0.792 c-0.002,0.438-0.355,0.793-0.793,0.792h-1.359c0.848,0.465,1.803,1.64,2.078,3.167c1.965-0.413,3.258-2.113,3.24-3.959 C16.115,6.095,14.607,4.958,12.969,4.958z M9.01,9.808v2.276c-0.001,0.437-0.354,0.792-0.792,0.791 c-0.438,0-0.793-0.354-0.792-0.791v-1.361c-0.464,0.849-1.64,1.804-3.167,2.078c0.413,1.967,2.112,3.26,3.958,3.241 c2.03-0.021,3.167-1.527,3.167-3.167C11.385,11.385,10.367,10.17,9.01,9.808z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#E9E9E9",
    cx: 8.219,
    cy: 8.125,
    r: 0.791
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefferralsProfile);
export default __webpack_public_path__ + "static/media/refferralsProfile.edcd81af7aa7e1e9ef08b20dbb3ac05a.svg";
export { ForwardRef as ReactComponent };